import React from 'react';
import PropTypes from 'prop-types';
import {shallowEqual, useSelector} from 'react-redux';
import {applyRound} from '@ey/utils';
import styled from 'styled-components';
import {getAccountById} from '../../../../selectors/Ares/selectors';
import {getCurrentMateriality} from '../../../../selectors/Ares/materiality';
import {UseGetInUserNumberFormatWithDecimals} from './AccountSummaryConfig';

function XMateriality({className, accountId}) {
	const {currentBalance} = useSelector((state) => getAccountById(state, accountId), shallowEqual) || {};

	const {teAmount} = useSelector((state) => getCurrentMateriality(state), shallowEqual);

	const multiplierSymbol = 'x';

	let xMateriality = '-';
	if (currentBalance !== null && currentBalance && teAmount) {
		xMateriality = UseGetInUserNumberFormatWithDecimals(applyRound(currentBalance / teAmount, 1)) + multiplierSymbol;
	}

	return (
		<StyledXMaterialitySection className={`StyledXMaterialitySection ${className}`}>
			<span className="text-renderer" title={xMateriality}>
				{xMateriality}
			</span>
		</StyledXMaterialitySection>
	);
}

XMateriality.propTypes = {
	className: PropTypes.string,
	accountId: PropTypes.number.isRequired
};

XMateriality.defaultProps = {
	className: 'xmateriality-cellrenderer'
};

export default XMateriality;

const StyledXMaterialitySection = styled.section`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	width: 100%;
	font-weight: 400;
	font-size: var(--px-12);
	line-height: var(--px-22);
	padding-right: var(--px-5);
	.text-renderer {
		display: block;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: auto;
		max-width: var(--px-65);
	}
`;
